import { Injectable } from '@angular/core';
import { DrawerPosition, DrawerRef, DrawerType, FireflyDrawerService } from '@capital-access/firefly/components';
import { ReportTemplateFormType } from '@capital-access/reporting/common';
import { ReportTemplateDrawerFormComponent } from '../components/report-template-drawer-form/report-template-drawer-form.component';

@Injectable()
export class DrawerService {
  private drawerRef!: DrawerRef;

  constructor(private drawerService: FireflyDrawerService) {}

  public openDrawer(
    localization: Record<string, string>,
    drawerAction?: ReportTemplateFormType | null,
    isReportingModule: boolean = false
  ): DrawerRef {
    let title = '';
    switch (drawerAction) {
      case ReportTemplateFormType.create:
        title = localization['createReportTemplate'];
        break;
      case ReportTemplateFormType.edit:
        title = localization['editReportTemplate'];
        break;
      case ReportTemplateFormType.duplicate:
      case ReportTemplateFormType.duplicateWithoutContinue:
        title = localization['createReportTemplate'];
        break;
      default:
        title = ''; // Default value if no match is found
        break;
    }

    this.drawerRef = this.drawerService.openDrawer(
      {
        title,
        type: DrawerType.Form,
        position: DrawerPosition.Right,
        rootCssClass: 'create-report-template-drawer',
        ...(!isReportingModule && drawerAction === ReportTemplateFormType.create ? { addBackButton: true } : {}),
        modalLocalizedInfo: {
          modalLeaveFormTitle: localization['modalLeaveFormTitle'],
          modalConfirmationMessage: localization['modalConfirmationMessage']
        }
      },
      ReportTemplateDrawerFormComponent
    );

    return this.drawerRef;
  }

  public closeDrawer() {
    this.drawerRef.close();
  }
}
